/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Sensor_TdsInputs */

const vi_irrigation_sensor_tds = /** @type {(inputs: Irrigation_Sensor_TdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TDS`)
};

/**

* @param {Irrigation_Sensor_TdsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_sensor_tds = /** @type {((inputs?: Irrigation_Sensor_TdsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Sensor_TdsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_sensor_tds(inputs)
});